import WaiterSales from './WaiterSales';

export default WaiterSales;
